import { GET_SALARY_DETAILS } from "../graphql/salaries";
import { SalaryType } from "../__generated__/graphql";
import { buildSalaryDetails } from "./factories";

export const buildGraphqlMock_GET_SALARY_DETAILS = () => {
    return {
        request: {
            query: GET_SALARY_DETAILS,
        },
        variableMatcher: () => true,
        newData: ({
            requestedSalary,
            requestedSalaryType,
        }: {
            requestedSalary: number;
            requestedSalaryType: SalaryType;
        }) => {
            if (requestedSalaryType === SalaryType.Gross) {
                return {
                    data: {
                        getSalaryDetails: buildSalaryDetails({
                            invoiceSalary: requestedSalary * 1.2,
                            baseSalary: requestedSalary * 1.1,
                            grossSalary: requestedSalary,
                            netSalary: requestedSalary * 0.8,
                            requestedSalaryType: SalaryType.Gross,
                        }),
                    },
                };
            }
            if (requestedSalaryType === SalaryType.Net) {
                return {
                    data: {
                        getSalaryDetails: buildSalaryDetails({
                            invoiceSalary: requestedSalary / 1.3,
                            baseSalary: requestedSalary / 1.2,
                            grossSalary: requestedSalary / 1.1,
                            netSalary: requestedSalary,
                            requestedSalaryType: SalaryType.Net,
                        }),
                    },
                };
            }
            if (requestedSalaryType === SalaryType.Invoice) {
                return {
                    data: {
                        getSalaryDetails: buildSalaryDetails({
                            invoiceSalary: requestedSalary,
                            baseSalary: requestedSalary / 1.1,
                            grossSalary: requestedSalary / 1.2,
                            netSalary: requestedSalary / 1.3,
                            requestedSalaryType: SalaryType.Invoice,
                        }),
                    },
                };
            }
            return {
                data: {
                    getSalaryDetails: buildSalaryDetails({
                        grossSalary: 3456,
                        netSalary: 3000,
                        requestedSalaryType: requestedSalaryType,
                    }),
                },
            };
        },
    };
};
